type Flags = {
  isSlimVersion?: boolean;
  isEmployee?: boolean;
  isPayingUser?: boolean;
  isVisitor?: boolean;
};

export const filter = (item: any, flags: Flags = {}) => {
  let output = true;

  const { flavour } = item;

  switch (flavour) {
    case 'hidden':
      output = false;
      break;
    case 'v2':
      output = flags.isSlimVersion === false;
      break;
    case 'slim-only':
      output = flags.isSlimVersion === true;
      break;
    case 'sloyd-only':
      output = flags.isEmployee === true;
      break;
    case 'users-only':
      output = flags.isVisitor !== true;
      break;
    case 'free-only':
      output = flags.isPayingUser === false;
      break;
  }

  return output;
};
